module.exports = __webpack_public_path__ + "static/harshal-review-1c577af95f05f0950083ec6e4374c077.png";